import React from 'react';

import { Box, keyframes } from '@mui/material';

import { classes } from '../styles';

import type { SxProps } from '@mui/material';
import type { FC } from 'react';

const DELAYS_IN_SECONDS = [1, 0.2, 0.4];

const blink = keyframes`
    0% {opacity: 1;}
    50% {opacity: 0;}
    100% {opacity: 1;}
  `;

const BlinkingDot: FC<{ delay: number; style?: SxProps }> = ({ delay, style }) => (
  <Box
    sx={{
      animation: `${blink} 1s ${delay}s linear infinite`,
      fontSize: '30px',
      ...style
    }}
  />
);

export const LoadingMessage = () => (
  <Box sx={classes.systemMessage}>
    Generating
    {DELAYS_IN_SECONDS.map((delay) => (
      <BlinkingDot key={delay} delay={delay} />
    ))}
  </Box>
);
